import { MinimalMediaTarget } from './minimal_target';
import { MediaManager } from './media_manager';

type MediaItem = {
   data: any;
   toWikiText: () => string;
};

type AcceptsFilter = 'profile_image' | 'wiki_media';

/**
 * Open the Media Manager and resolve with the chosen item. Note: matching
 * the original behavior, the promise never settles when the user cancels.
 *
 * MediaManager.browse() opens the React Media Manager; the chosen item
 * arrives here as a legacy MediaItem.
 */
export const activateMediaManager = (accepts: AcceptsFilter): Promise<MediaItem> =>
   new Promise<MediaItem>(resolve => {
      const target = new MinimalMediaTarget({
         customAttach: (mediaItem: MediaItem, finished: any) => {
            if (mediaItem) {
               resolve(mediaItem);
            }
            // Finished expects the old media item in the case of mutation
            // and a success boolean.
            finished(null, true);
         },
         accepts,
      });
      MediaManager.browse(target);
   });
